module.exports = __webpack_public_path__ + "static/media/member education icon.cb4a82bd.svg";